import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { NotificationType } from 'application/notification/model/notification.type';
import { Notification } from 'domain/notification/notification';
import { NotificationMeeting } from 'domain/notification/notification-meeting';
import { NotificationOutput } from 'infrastructure/graphql/messaging/notification/model/notification.output';

@Injectable({ providedIn: 'root' })
export class NotificationConverterService {
	public notificationAsEntity(output: NotificationOutput): Notification {
		if (!output) {
			return null;
		}
		return new Notification(
			output.id,
			output.taskId,
			new Date(output.creationDateTime),
			output.orgModuleId,
			output.documentId,
			output.sourceUserId,
			output.targetUserId,
			NotificationType[output.type],
			output.contactsName || [],
			output.updateTimestamp,
			output.meeting
				? new NotificationMeeting(
						output.meeting.coachId,
						new Date(output.meeting.startDate),
						new Date(output.meeting.endDate)
				  )
				: null
		);
	}

	public notificationsAsEntities(outputs: NotificationOutput[]): Notification[] {
		return reject(outputs, isNil).map((output) =>
			this.notificationAsEntity(output)
		);
	}
}
